import { parseUnsignedIntStrict } from "@shared/lib/utils";

export function parseDocumentSettingsIdToNumber(id: string | null): number | null {
  if (id) {
    return parseUnsignedIntStrict(id);
  }
  return null;
}
